/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import cn from 'classnames';
import { Box, superBoxStyle } from '@vital-ui/react-utils';
import { defaultTheme } from '@vital-ui/react-theme';
var Btn = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  background-color: #ffffff;\n  display: block;\n  box-shadow: 1px 0 0 1px rgba(196, 210, 235, 0.2);\n  transition: all 120ms ease-in;\n  box-sizing: border-box;\n  border: 1px solid ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  background-color: #ffffff;\n  display: block;\n  box-shadow: 1px 0 0 1px rgba(196, 210, 235, 0.2);\n  transition: all 120ms ease-in;\n  box-sizing: border-box;\n  border: 1px solid ", ";\n\n  ",
    ";\n\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.switch.buttonSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.switch.buttonSize;
}, function (props) { return (props.round ? '50%' : '4px'); }, function (_a) {
    var theme = _a.theme;
    return theme.form.borderColor;
}, function (_a) {
    var theme = _a.theme, icon = _a.icon;
    return icon && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: 36px;\n      height: 36px;\n      position: absolute;\n      top: -6px;\n      left: -6px;\n      text-align: center;\n      line-height: 36px;\n      font-size: 1.2rem;\n      color: ", ";\n    "], ["\n      width: 36px;\n      height: 36px;\n      position: absolute;\n      top: -6px;\n      left: -6px;\n      text-align: center;\n      line-height: 36px;\n      font-size: 1.2rem;\n      color: ", ";\n    "])), theme.switch.icon);
}, superBoxStyle);
Btn.defaultProps = {
    theme: defaultTheme,
};
var checkedStyle = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &:checked {\n    & + label {\n      background-color: ", ";\n      box-shadow: 0 0 0 1px ", ";\n\n      ", " {\n        transform: translate3d(30px, 0, 0);\n        border-color: ", ";\n        box-shadow: ", ";\n      }\n    }\n  }\n"], ["\n  &:checked {\n    & + label {\n      background-color: ", ";\n      box-shadow: 0 0 0 1px ", ";\n\n      ", " {\n        transform: translate3d(30px, 0, 0);\n        border-color: ", ";\n        box-shadow: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.switch.checked;
}, function (_a) {
    var theme = _a.theme;
    return theme.switch.checked;
}, Btn, function (_a) {
    var theme = _a.theme;
    return theme.switch.checked;
}, function (_a) {
    var theme = _a.theme;
    return theme.switch.shadow;
});
var disabledStyle = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  &:disabled {\n    & + label {\n      background-color: ", ";\n      cursor: not-allowed;\n      point-events: none;\n\n      ", " {\n        background-color: ", ";\n        box-shadow: none;\n      }\n    }\n  }\n"], ["\n  &:disabled {\n    & + label {\n      background-color: ", ";\n      cursor: not-allowed;\n      point-events: none;\n\n      ", " {\n        background-color: ", ";\n        box-shadow: none;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.switch.disabled;
}, Btn, function (_a) {
    var theme = _a.theme;
    return theme.switch.disabled;
});
var Input = styled.input(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: none;\n\n  ", ";\n  ", ";\n"], ["\n  display: none;\n\n  ", ";\n  ", ";\n"])), checkedStyle, disabledStyle);
Input.defaultProps = {
    theme: defaultTheme,
};
var Label = styled('label')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 53px;\n  height: 24px;\n  border-radius: ", ";\n  background-color: ", ";\n  padding: 1px;\n  color: #fff;\n  box-shadow: 0 0 0 1px\n    ", ";\n  cursor: pointer;\n"], ["\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 53px;\n  height: 24px;\n  border-radius: ", ";\n  background-color: ", ";\n  padding: 1px;\n  color: #fff;\n  box-shadow: 0 0 0 1px\n    ", ";\n  cursor: pointer;\n"])), function (props) { return (props.round ? '24px' : '4px'); }, function (_a) {
    var theme = _a.theme;
    return theme.switch.label.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.switch.label.shadowColor;
});
Label.defaultProps = {
    theme: defaultTheme,
};
var Text = styled('div')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  top: 3px;\n  right: 8px;\n  font-size: 13px;\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n  color: ", ";\n  text-align: center;\n  transition: all 300ms ease-in;\n  opacity: 1;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  top: 3px;\n  right: 8px;\n  font-size: 13px;\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n  color: ",
    ";\n  text-align: center;\n  transition: all 300ms ease-in;\n  opacity: 1;\n  pointer-events: none;\n"])), function (_a) {
    var theme = _a.theme, checked = _a.checked;
    return checked
        ? theme.switch.label.checkedColor
        : theme.switch.label.color;
});
Text.defaultProps = {
    theme: defaultTheme,
};
// @ts-ignore
var TextOff = styled(Text)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: ", ";\n"], ["\n  display: ", ";\n"])), function (props) { return (props.checked ? 'none' : 'block'); });
// @ts-ignore
var TextOn = styled(Text)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: ", ";\n  left: 8px;\n"], ["\n  display: ", ";\n  left: 8px;\n"])), function (props) { return (props.checked ? 'block' : 'none'); });
/**
 * @render react
 * @name Switch
 * @description Toggle boolean value
 * @example
 * <Switch
 *  round
 * />
 */
var Switch = /** @class */ (function (_super) {
    __extends(Switch, _super);
    function Switch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCheck = function () {
            if (_this.props.disabled) {
                return;
            }
            if (_this.props.onChange) {
                _this.props.onChange(!_this.props.checked);
            }
        };
        return _this;
    }
    Switch.prototype.render = function () {
        var _a = this.props, round = _a.round, disabled = _a.disabled, style = _a.style, className = _a.className, checked = _a.checked, defaultChecked = _a.defaultChecked, iconLabelBack = _a.iconLabelBack, onChange = _a.onChange, off = _a.off, on = _a.on, icon = _a.icon, button = _a.button, buttonProps = _a.buttonProps, rest = __rest(_a, ["round", "disabled", "style", "className", "checked", "defaultChecked", "iconLabelBack", "onChange", "off", "on", "icon", "button", "buttonProps"]);
        return (React.createElement(Box, __assign({ display: "inline-block", style: style, className: cn('vital__switch', className), onClick: this.onCheck }, rest),
            React.createElement(Input, { defaultChecked: defaultChecked, type: "checkbox", checked: checked, onChange: function () { }, disabled: disabled }),
            React.createElement(Label, { round: round, disabled: disabled },
                React.createElement(TextOff, { checked: checked }, off),
                button ? (button) : (React.createElement(Btn, __assign({ round: round, disabled: disabled }, buttonProps), icon)),
                React.createElement(TextOn, { checked: checked }, on))));
    };
    Switch.defaultProps = {
        round: false,
        disabled: false,
        iconBtn: undefined,
        iconLabelFront: undefined,
        iconLabelBack: undefined,
    };
    return Switch;
}(Component));
export { Switch };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=Switch.js.map